import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import {
  bookingContainersRoute,
  bookingCustomsRoute,
  bookingDetailsRoute,
  bookingDocumentsRoute,
  bookingPriceBreakdownRoute,
  bookingRootRoute,
} from '../features/overview/routes'
import { bookingsCreateRoute } from '../features/wizard/routes/BookingCreateWizardRoot'

const manualQuoteBookRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/quotes/$quoteId/book',
  beforeLoad: async ({ context, location }) => {
    await ensureAuthenticatedUser({ context, location })
    if (context.isReady && !context.isCustomerActive) {
      throw redirect({
        to: '/',
      })
    }
  },
}).lazy(() => import('../features/mq-select/routes/ManualQuoteBookRoot').then((d) => d.Route))

export const bookingsRoutes = [
  bookingsCreateRoute,
  manualQuoteBookRoute,
  bookingRootRoute,
  // Since the routes below all use the root route as the parent, they are not children of the bookingRootRoute
  bookingDetailsRoute,
  bookingContainersRoute,
  bookingPriceBreakdownRoute,
  bookingCustomsRoute,
  bookingDocumentsRoute,
]
